import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const more: ISVGPersonalProps = {
  viewBox: '0 0 17.823 17.823',
  content: (
    <g id="more_-_icon" data-name="more - icon" transform="translate(-9006 -3037)">
      <rect
        id="Rectangle_2984"
        data-name="Rectangle 2984"
        width="17.823"
        height="17.823"
        transform="translate(9006 3037)"
        fill="none"
      />
      <path
        id="Path_7104"
        data-name="Path 7104"
        d="M1.379,7.582a6.2,6.2,0,1,1,6.2,6.2,6.2,6.2,0,0,1-6.2-6.2M7.582,0a7.582,7.582,0,1,0,7.582,7.582A7.582,7.582,0,0,0,7.582,0M3.446,7.582A1.034,1.034,0,1,1,4.48,8.616,1.034,1.034,0,0,1,3.446,7.582m3.1,0A1.034,1.034,0,1,1,7.582,8.616,1.034,1.034,0,0,1,6.548,7.582m3.1,0a1.034,1.034,0,1,1,1.034,1.034A1.034,1.034,0,0,1,9.65,7.582"
        transform="translate(9007.33 3038.33)"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  ),
};
